export const MAX_PRICE = 4999999;
//# sourceMappingURL=constants.js.map